import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { toast } from 'react-toastify';
import useModal, { MODAL_LG, MODAL_SM } from '../../../../theme/Component/hooks/useModal';
import { ListMenu } from '../../../../theme/Component/ListMenu';
import { BasicPage } from '../../../../theme/Component/BasicPage';
import { SelectorTypeForm } from '../SelectorTypeForm';
import { BasicTable } from '../../../../theme/Component/BasicTable';
import { ModalConfirm } from '../../../../theme/Component/ModalConfirm';
import { Modal } from '../../../../theme/Component/Modal';
import { FormParamDinamic } from './FormParamDinamic/FormParamDinamic';
import { _FormTypeDinamic, _single } from '../../../../../core/services/dataBean/EntityCatalog';

interface Props {
    filtro?: string;
    isModal?: boolean;
    _onChange?: Function;
}

export const FormTypeDinamic = ({ filtro, isModal, _onChange }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_FormTypeDinamic)

    const [groupSelected, setGroupSelected] = useState<string>('');

    const modal = useModal("", MODAL_LG);
    const modalC = useModal(`Eliminar Formulario ${bean.Name}`, MODAL_SM);
    const modalProps = useModal(`Campos del formulario ${bean.Name}`, MODAL_LG);

    const head = [
        { title: 'ID', property: "IDFormType", visible: false },
        { title: 'Codigo', property: 'CodeForm' },
        { title: 'Nombre', property: 'Name' },
        { title: 'Descripcion', property: 'Description' },
        { title: 'Codigo de Grupo', property: 'GroupCode', visible: false },
    ]

    const setRowBean = (bean: any) => {
        _onChange?.(bean);
        setBean(bean);
    }

    useEffect(() => {
        getListaFiltro();
    }, [groupSelected, filtro])

    const getListaFiltro = () => {
        let props: any = {}

        if (filtro) props.GroupCode = filtro;
        if (groupSelected) props.GroupCode = groupSelected;

        instance.getFormTypeCatalogPorPropiedadesLike(props, null).then(
            (resp: any) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) });
    }

    const agregarItem = () => {
        setBean({
            GroupCode: filtro ? filtro : '',
            State: 1
        });
        modal.open("Agregar formulario dinamico");
    }

    const eliminarItem = () => {

        instance.deleteFormType(bean.IDFormType).then(
            (resp: any) => {
                getListaFiltro();
                modalC.close();
            }
        ).catch(err => { toast.error(err) });
    }

    const updateItem = () => {
        instance.updateFormType(bean).then(
            (resp: any) => {
                getListaFiltro();
                modal.close();
            }
        ).catch(err => { toast.error(err) });

    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: agregarItem }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { modal.open(`Editar Formulario ${bean.Name}`); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: true, evento: () => { modalC.open(); } },
            { titulo: 'Propiedades', icono: 'ri-file-user-line', visible: true, evento: () => { modalProps.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const baseComponent = () => {
        return (
            <>
                <div className="row">
                    {!filtro &&
                        <div className="col-6">
                            <SelectorTypeForm value={groupSelected} onChange={(e: string) => setGroupSelected(e)} />
                        </div>
                    }
                    <div className="col-md-12 p-2">
                        <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setRowBean}></BasicTable>
                    </div>
                </div>

                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={() => { eliminarItem() }}>
                    {bean.Name}
                </ModalConfirm>

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { updateItem() }}>
                    <div className="row">
                        <div className="col-md-4">
                            <label className="form-label">Grupo de Formulario</label>
                            <input type="text" className="form-control" value={bean.GroupCode}
                                onChange={(e) => { setBean({ ...bean, 'GroupCode': e.target.value }) }} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Codigo <small>(Identificacion)</small></label>
                            <input type="number" className="form-control" value={bean.CodeForm} onChange={(e) => {
                                const valor = e.target.value ? Number(e.target.value) : null
                                setBean({ ...bean, 'CodeForm': valor })
                            }} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Nombre</label>
                            <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, 'Name': e.target.value }) }} />
                        </div>
                        <div className="col-md-12">
                            <label className="form-label">Descripcion</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, 'Description': e.target.value }) }}></textarea>
                        </div>

                    </div>
                </Modal>

                <Modal modal={modalProps.modal} updateModal={modalProps.setModal}>
                    <FormParamDinamic idSelector={bean.IDFormType} CodePar={bean.CodeForm} />
                </Modal>
            </>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Formularios Dinamicos">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}
